
import { Component, Vue } from 'vue-property-decorator'
import { routeToFilters } from '../../../pu-links/infrastructure/routeToFilters'

@Component
export default class LowResultsBounds extends Vue {
  get modifyFilters() {
    const filters = routeToFilters(this.$route)
    return {
      area: filters.previousPoint?.area,
      bounds: undefined,
      hierarchyPath: filters.previousPath,
      placename: filters.previousPoint?.placename,
      previousPath: '',
      previousPoint: undefined,
    }
  }
}
